// eslint-disable-next-line import/prefer-default-export
export const FREIGABESTATUS_KUNDENFREIGABE_OFFEN = '4';
